import { useTranslation } from '../i18n';
import ButtonNB from './ui-nb/ButtonNB';

export default function HeroNB() {
  const { t, language } = useTranslation();

  return (
    <section className="bg-nb-cream min-h-screen flex items-center justify-center">
      <div className="max-w-4xl mx-auto px-4 py-12 md:py-20 text-center">
        {/* Headline — massive, solid black, no gradients */}
        <h1 className="font-nb font-bold text-4xl md:text-5xl lg:text-7xl text-nb-black mb-4 md:mb-6 leading-touch px-2">
          {t('hero.headline')}
        </h1>

        {/* Sub-headline */}
        <p className="text-base md:text-lg text-nb-text-secondary mb-8 md:mb-10 max-w-xl mx-auto leading-relaxed px-4">
          {t('hero.subheadline')}
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 px-4">
          <ButtonNB variant="primary" size="lg">
            <a href={`/${language}/register`} className="block w-full sm:w-auto">{t('hero.ctaStart')}</a>
          </ButtonNB>
          <a
            href="#features"
            className="text-nb-text-secondary hover:text-nb-black text-sm font-medium transition-colors py-2"
          >
            {t('hero.ctaHowItWorks')} &rarr;
          </a>
        </div>
      </div>
    </section>
  );
}
